import React, { useEffect, useState } from 'react'
import { get } from '../../util/request';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';

const RencanaIzin = () => {
  const [state, setState] = useState({
    absensList: '',
    form: {
      employee_id: '',
      company_id: '',
    },
    filter: 'all',
    loading: true
  })

  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      var url = `public/api/v1/member/attendance/absence_list?employee_id=${user.employee_id}&company_id=${user.company_id}&approved=1&unapproved=1&waiting=1`

      if (state.filter === 'approved') {
        url = `public/api/v1/member/attendance/absence_list?employee_id=${user.employee_id}&company_id=${user.company_id}&approved=1`
      } else if (state.filter === 'unapproved') {
        url = `public/api/v1/member/attendance/absence_list?employee_id=${user.employee_id}&company_id=${user.company_id}&unapproved=1`
      } else if (state.filter === 'waiting') {
        url = `public/api/v1/member/attendance/absence_list?employee_id=${user.employee_id}&company_id=${user.company_id}&waiting=1`
      }

      getListAbsen(url)
    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.filter])

  const getListAbsen = (url) => {
    get(
      url,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState({
          ...state,
          absensList: success.data.Data,
          loading: false
        })

      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }



  const formatDate = (sDate, eDate) => {
    const dt1 = new Date(sDate);
    const dt2 = new Date(eDate);
    var d1 = format(dt1, 'dd') + " " + format(dt1, 'MMMM') + " - " + format(dt2, 'dd') + " " + format(dt2, 'MMMM') + " " + format(dt2, 'yyyy')
    return d1
  }

  const handleSelected = (e) => {
    setState(prevState => {
      return {
        ...prevState,
       filter: e.target.value
      }
    })
  }
  return (
    state.loading ? "" :
      <div className='w-full h-screen grid-cols-1 sm:grid-cols-2 bg-bg-primary'>
        <div className='w-full h-20 bg-real-white'>
          <div className='flex items-center h-full px-4'>
            <a href={process.env.PUBLIC_URL + "/home"}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
            </a>
            <p className='px-4'>Rencana Izin</p>
          </div>
        </div>
        <div className='w-full px-4 bg-real-white'>
          <div className='flex justify-between'>
            <p className='font-bold'>Rencana Izin/Absen</p>
            <a href={process.env.PUBLIC_URL + "/buat-jadwal"} className="block px-8 rounded-full bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              Izin Sekarang
            </a>
          </div>
          <div className='w-1/2 h-full py-4'>
            <select id="countries" onChange={(e) => handleSelected(e)} className="bg-real-white border border-bg-primary text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option value="all">Semua</option>
              <option value="approved">Disetujui</option>
              <option value="waiting">Diproses</option>
              <option value="unapproved">Ditolak</option>
            </select>

          </div>
        </div>
        <div>

          <div className='grid grid-cols-1'>
            {state.absensList.map((item,index) => (
              <div className="grid grid-cols-6 p-4 mx-4 mt-4 rounded-lg bg-real-white" key={index}>
                <p className='text-base'>1</p>
                <p className='col-span-3 text-base font-bold'>{item.employee?.employee_fullname}</p>
                <div className='flex col-span-2 text-xs text-grey-dark'>
                  <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-orange-500 rounded-md ring-1 ring-inset ring-gray-500/10">Diproses</span>
                  <span className="inline-flex items-center px-2 py-1 mx-2 text-xs font-medium text-white bg-orange-500 rounded-md ring-1 ring-inset ring-gray-500/10">
                    <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/bar-left.svg"} className='w-4' />
                  </span>
                </div>
                <p className='text-base'></p>
                <div className='flex flex-col w-full col-span-5 text-left place-items-start'>
                  <p className='py-2'>Pada tanggal {formatDate(item.ar_start_date, item.ar_end_date)}</p>
                  <p className=''>Alasan: {item.ar_reason}</p>
                </div>
              </div>
            ))}

          </div>
        </div>




      </div >
  )
}

export default RencanaIzin